import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useParams, useNavigate } from "react-router-dom";

import {
      FormButton,
      FormDescription,
      FormImage,
      FormInput,
      FormSelect,
      FormSeo,
      FormStatusSelect,
      FormTextarea,
} from "../../components/form";
import { Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import { privateApi } from "../../api";

const BlogEdit = () => {
      const { blogId } = useParams();

      const [categories, setCategories] = useState([]);
      const [isLoading, setIsLoading] = useState(false);

      const [title, setTitle] = useState("");
      const [summary, setSummary] = useState("");
      const [image, setImage] = useState("");
      const [imageUrl, setImageUrl] = useState("");
      const [category, setCategory] = useState("");
      const [description, setDescription] = useState("");
      const [slug, setSlug] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const [seoTitle, setSeoTitle] = useState(null);
      const [seoKeyword, setSeoKeyword] = useState(null);
      const [seoDescription, setSeoDescription] = useState(null);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/blogs/${blogId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setSlug(response.data.blog.slug);
                              setTitle(response.data.blog.title);
                              setSummary(response.data.blog.summary);
                              setCategory(response.data.blog.category_id);
                              setDescription(response.data.blog.description);
                              setImageUrl(response.data.blog.image);
                              setStatus(response.data.blog.status);
                              setSeoTitle(response.data.blog.seo_title);
                              setSeoKeyword(response.data.blog.seo_keyword);
                              setSeoDescription(
                                    response.data.blog.seo_description
                              );
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const navigate = useNavigate();

      useEffect(() => {
            loadData();
      }, []);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  slug: slug,
                  title: title,
                  summary: summary,
                  description: description,
                  category: category,
                  image: image,
                  status: status,
                  seo_title: seoTitle,
                  seo_keyword: seoKeyword,
                  seo_description: seoDescription,
            };
            let updatedSlug = false;

            const handleUpdateSlug = () => {
                  if (updatedSlug) {
                        navigate(`/dashboard/blogs/${updatedSlug}/edit`);
                  }
            };
            await privateApi
                  .post(`/dashboard/blogs/${blogId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                              updatedSlug = slug;
                              handleUpdateSlug();
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.summary) {
                                    toast.error(response.data.message.summary);
                              }
                              if (response.data.message.description) {
                                    toast.error(
                                          response.data.message.description
                                    );
                              }
                              if (response.data.message.category) {
                                    toast.error(response.data.message.category);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.slug) {
                                    toast.error(response.data.message.slug);
                              }
                              if (response.data.message.seo_description) {
                                    toast.error(
                                          response.data.message.seo_description
                                    );
                              }
                              if (response.data.message.seo_title) {
                                    toast.error(
                                          response.data.message.seo_title
                                    );
                              }
                              if (response.data.message.seo_keyword) {
                                    toast.error(
                                          response.data.message.seo_keyword
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      const loadCategories = async () => {
            setIsLoading(true);
            await privateApi
                  .get(`/dashboard/blogs/categories/list`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories(response.data.categories);
                              setIsLoading(false);
                        }
                        if (response.data.result === "error") {
                              toast.error(response.data.message);
                              setIsLoading(false);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });
      };

      useEffect(() => {
            loadCategories();
      }, []);

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Create Blog">
                                                <LinkButton
                                                      link="/dashboard/blogs"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="row g-3">
                                                      <FormInput
                                                            title="Title"
                                                            required={true}
                                                            classes={7}
                                                            value={title}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slug"
                                                            classes={5}
                                                            required={true}
                                                            handleChange={
                                                                  setSlug
                                                            }
                                                            value={slug}
                                                      />
                                                      <FormSelect
                                                            title="Category"
                                                            loading={isLoading}
                                                            selected={category}
                                                            classes={4}
                                                            options={categories}
                                                            setData={
                                                                  setCategory
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormTextarea
                                                            title="Summary"
                                                            required={true}
                                                            handleChange={
                                                                  setSummary
                                                            }
                                                            value={summary}
                                                      />
                                                      <FormDescription
                                                            title="Description"
                                                            required={true}
                                                            description={
                                                                  description
                                                            }
                                                            setDescription={
                                                                  setDescription
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <FormSeo
                                          setSeoDescription={setSeoDescription}
                                          setSeoTitle={setSeoTitle}
                                          setSeoKeyword={setSeoKeyword}
                                          description={seoDescription}
                                          keyword={seoKeyword}
                                          title={seoTitle}
                                    />

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default BlogEdit;
